import {
  getTokenDetail,
  getContractTransactions
} from '../../config/apiServe/scanner'
import BTY_Contract from '../../utils/web3'
export default {
  data() {
    return {
      tab: 0, // 0 --> 交易记录，1 --> 持有人
      searchAddress: "",
      propsAdr: '',
      tokenName: '',
      tokenAddress: '',
      isSearch: true,
      TokenInfo: {},
      loading: false,
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      txs: [],
      holders: []
    };
  },
  computed: {
    LoadingSucc() {
      return !this.loading;
    }
  },
  watch: {
    '$route.query.tokenAdr'(newVal) {
      if (newVal) {
        this.tokenAddress = newVal;
        this.loadTokenDetail();
      }
    }
  },
  mounted() {
    this.tokenAddress = this.$route.query.tokenAdr || '';
    this.propsAdr = this.$route.query.adr || '';
    if (this.tokenAddress) {
      this.loadTokenDetail();
    }
  },
  methods: {
    // 加载Token详情
    async loadTokenDetail() {
      if (!this.tokenAddress) return;
      
      this.loading = true;
      try {
        const response = await getTokenDetail(this.tokenAddress);
        if (response.code === 0 && response.data) {
          const data = response.data;
          // 转换数据格式以适配组件
          this.TokenInfo = {
            address: data.address,
            symbol: data.symbol,
            name: data.name,
            decimals: data.decimals,
            total: data.total_supply, // 原始总供应量
            total_formatted: data.total_supply_formatted, // 格式化后的总供应量
            createdTime: data.deploy_time, // 部署时间
            deploy_time: data.deploy_time,
            deploy_block_number: data.deploy_block_number,
            deploy_tx_hash: data.deploy_tx_hash,
            deployer: data.deployer,
            type: data.type,
            verification_status: data.verification_status,
            icon: require("../../assets/img/coin/baseCoin.png"), // 默认图标
            holders: data.holders || 0, // 如果接口没有返回，默认为0
            txCount: 0, // 初始化为0，后续通过其他接口获取
            rmb: data.rmb || 0, // 如果接口没有返回，默认为0
            nickname: data.name, // 用于显示昵称
            lockNum: 0 // 初始化锁仓数量
          };
          
          this.tokenName = data.symbol;
          // TokenInfo 赋值完成后再获取锁仓数量，避免竞态条件导致数据被覆盖
          this.getBTYBalance();
        } else {
          this.$notify({
            title: '提示',
            message: response.message || '获取Token详情失败',
            type: 'error'
          });
        }
      } catch (error) {
        console.error('加载Token详情失败:', error);
        this.$notify({
          title: '提示',
          message: '获取Token详情失败',
          type: 'error'
        });
      } finally {
        this.loading = false;
      }
    },
    searchAdr() {
      // if (this.searchAddress.length < 34) {
      //   this.$notify({
      //     title: '提示',
      //     message: '地址错误',
      //     type: 'warning'
      //   })
      //   return
      // }
      this.propsAdr = this.searchAddress
      this.searchAddress = ''
    },
    tabChange(tab) {
      this.tab = tab
      this.propsAdr = ''
      this.pages.currentPage = 1
      this.pages.pageSize = 10
      this.$router.push({
        path: '/tokenDetail',
        query: {
          tokenAdr: this.tokenAddress
        }
      })
      if (tab === 1) {
        this.pages.total = this.TokenInfo.holders || 0
      }
    },
    pageChange(page) {
      this.pages.currentPage = page;
    },
    sizeChange(size) {
      this.pages.pageSize = size;
      this.pages.currentPage = 1
    },
    getBTYBalance() {
      console.log(BTY_Contract.methods);
      BTY_Contract.methods.cumulativeLockInfo(this.tokenAddress).call().then(res => {
        // console.log(res.amount/1e18)
        this.TokenInfo.lockNum = parseFloat(res.amount/1e18)
        console.log(this.TokenInfo.lockNum);
        
      })
    },
  }
}